import { clientPageTypeEnum } from '@app/core/enums';

export type BlockContent = Record<string, any>;

export interface StructureContent {
  id: string;
  client_id: string;
  structure_type: string;
  title: any;
  is_indexed: boolean;
  is_active: boolean;
  show_menu: boolean;
  show_footer: boolean;
  is_default: boolean;
  is_default_for_archive: boolean;
  type: clientPageTypeEnum;
  types: PageType[];
  seo: PageSeo;
  lang_url?: string;
  languages_list: string[];
  page_type_settings: PageTypeSettings;
  structure: BlockContent[];

  [key: string]: any;
}

export interface PageTypeSettings {
  display: boolean;
  is_list: boolean;
  is_main_page: boolean;
  is_preview: boolean;
  name: string;
  show_default_pages: boolean;
  show_default_pages_for_archive: boolean;
  show_is_indexed: boolean;
  show_meta_title: boolean;
  show_og_image: boolean;
  show_seo: boolean;
  show_slug: boolean;
  translations: {
    locale: string;
    name: string;
  }[];
  type: number;
}

export interface PageSettings {
  lang_url: string;
  languages_list?: string[];
  is_active?: boolean;
  title: string;
  enabled: boolean;
  type: string | null;
  showMenu: boolean;
  showFooter: boolean;
  defaultTemplate: boolean;
  defaultArchiveTemplate: boolean;
  types: Tag;
}

export interface PageSeo {
  meta_tags: SeoTag[];
  meta_title: Record<string, string | null>;
  meta_description: Record<string, string | null>;
  meta_tags_ids: number[];
  slug: Record<string, string>;
  isIndexed: boolean;
}

export interface SeoTag {
  name?: string;

  [key: string]: any;
}

export enum VERSION_TYPE {
  WORKING = 'working',
  ORIGINAL = 'original',
  ALL = 'all',
}

export enum STRUCTURE_TYPE {
  MATRIX = 'matrix',
  BLOCK = 'block',
  ALL = 'all',
}

export interface InnerHtml {
  innerHTML: string;
  length: any;
}

export interface TagTranslation {
  id: number;
  locale: string;
  name: string;
  tagId: number;
}

export interface Tag {
  id: number;
  clientId: number;
  customOrder: number;
  name: string;
  translations: TagTranslation[];
}

export interface HTMLElementModel {
  data: any;
  anchor: string;
}

export interface SliderSettings {
  data: any;
  anchor: string;
}

export interface SliderSettingsAnimation {
  animationDelay: number;
  animationDuration: number;
  animationType: string;
  sliderType: string;
}

export interface BlockSlider {
  uId: string;
  backgroundColor: string;
  backgroundImage: string;
  isActive?: boolean;
}

export interface PageType {
  type: number;
  id: number;
  name: string;
  translations: {
    locale: string;
    name: string;
  }[];
}

/**
 * Interfejs reprezentujący strukturę bloku treści w systemie CMS
 * @remarks Odzwierciedla strukturę danych z endpointów zarządzania treścią
 */
export interface SliderBlockContent {
  /** Unikalny identyfikator bloku (może być null dla nowych elementów) */
  id: string | null;
  /** ID rodzica w hierarchii bloków */
  parent_id: string;
  /** Zawartość tekstowa bloku */
  content: string | null;
  /** Typ bloku zgodny z enum BlockTypeEnum */
  type: number;
  /** Poziom zagnieżdżenia w strukturze drzewiastej */
  node: number;
  /** Kolejność w sortowaniu niestandardowym */
  custom_order: number;
  /** Dziecięce elementy bloku */
  children: any[];
  /** Pola podlegające tłumaczeniom */
  translated_fields: any[];
  /** Tłumaczenia zawartości bloku */
  translations: any[];
  /** ID powiązanego medium */
  media_id: number | null;
  /** Lista ID mediów powiązanych z blokiem */
  media_ids: number[];
  /** Tekst alternatywny dla mediów */
  media_alt: string | null;
  /** Konfiguracja akcji dla bloku */
  action: SliderBlockAction;
  /** Style CSS przypisane do bloku */
  styles: SliderBlockStyles;
  /** Ustawienia konfiguracyjne bloku */
  settings: {
    [key: string]: any;
    edited_elements: number;
  };
  /** ID specjalnego bloku (np. slidera) */
  special_block_id: number | null;
  /** Status aktywności bloku */
  is_active: boolean;
  /** Flaga zabezpieczenia przed modyfikacjami */
  is_read_only: boolean;
  /** ID powiązanego odnośnika */
  href_id: string | null;
  /** Kotwa HTML */
  anchor: string | null;
  /** Nazwa domyślnego stylu */
  default_style_name: string | null;
  /** Unikalny identyfikator w formacie UUID */
  u_id: string;
  /** Kolejność w tabulacji */
  tabindex: number;
  /** Status zaznaczenia */
  selected: boolean;
  /** Typ specjalnego bloku */
  special_block_type: number | null;
  /** Konfiguracja specjalnego bloku */
  special_block: any | null;
  /** Główne medium przypisane do bloku */
  media: any | null;
  /** Lista wszystkich mediów powiązanych z blokiem */
  medias: any[] | null;
}

/**
 * Interfejs konfiguracji akcji bloku
 * @remarks Obsługuje różne typy akcji (nawigacja, modal, itp.)
 */
export interface SliderBlockAction {
  /** Typ akcji zgodny z enum ActionTypeEnum */
  action_type: number;
}

/**
 * Interfejs struktur stylów bloku
 * @remarks Uwzględnia responsywne breakpointy i specyficzne właściwości CSS
 */
export interface SliderBlockStyles {
  /** Style podstawowe */
  all: {
    basic: Record<string, string | number>;
  };
}

export interface UploadPhoto {
  u_id: string;
  media_id: string | null;
  url: string | null;
  alt: string | null;
}


export interface Href {
  hrefType: 1;
  hrefTarget: 0;
  linkDescription: string;
  hrefUrls: HrefUrls;
  noFollow: boolean;
  anchor: string | null;
}

export type HrefUrls = Record<string, string>;
